import type { PhaseDurationValue } from 'Automations/nodeDefinitions/conditions/helpers/functionStrings/phase'

// A stored phase duration is one day shorter because its end date is inclusive.
const INCLUSIVE_END_DAY_OFFSET = 1

export const EMPTY_PHASE_DURATION_INPUT: PhaseDurationValue = {
  years: 0,
  months: 0,
  days: 0
}

export const phaseDurationToInput = (
  duration: PhaseDurationValue
): PhaseDurationValue => ({
  ...duration,
  days: duration.days + INCLUSIVE_END_DAY_OFFSET
})

export const phaseDurationFromInput = (
  duration: PhaseDurationValue
): PhaseDurationValue => ({
  ...duration,
  days: duration.days - INCLUSIVE_END_DAY_OFFSET
})
